import { Box, BoxProps, Container, Grid } from '@mui/material'

import AdvertisementCard, {
  type AdvertisementCard as AdvertisementCardProps
} from '@/components/base/advertisement-card'

export type AdvertisementGridProps = BoxProps &
  Partial<{
    items: AdvertisementCardProps[]
  }>

const AdvertisementGrid = ({ items, ...props }: AdvertisementGridProps) => {
  return (
    <Box {...props}>
      <Container>
        <Grid container>
          {items?.map((item, index) => (
            <AdvertisementCard
              key={`item-${index}`}
              size={{ xs: 4, sm: 4, md: 4 }}
              skeleton={false}
              {...item}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default AdvertisementGrid
